<template>
  <div>
    <div class="title-header">
      <div class="title-header-font">资料下载</div>
    </div>
    <!--面包屑-->
    <CurrentLocal :titles="titles"></CurrentLocal>
    <!--主要内容-->
    <div style="width: 1200px; margin: 10px auto; min-height: 500px">
      <download-item
        v-for="(downloadItemData, count) in downloadItemsData" :key="count" :num="(count + 1)"
        :downloadItemData="downloadItemData"></download-item>
    </div>

    <!--下载对话框-->
    <el-dialog title="下载详情" :visible.sync="dialogVisible" :before-close="pushToDownload" width="50%">
      <!--下载表格-->
      <el-table :data="gridData"
        :cell-class-name="tableItemCenter" header-cell-class-name="textCenter" class="table-font">
        <!--第一列-->
        <el-table-column property="item" label="项目" width="250"></el-table-column>
        <!--第二列-->
        <el-table-column property="description" label="描述">
          <!--eslint-disable-next-line vue/no-unused-vars-->
          <template slot-scope="scope">
            <!--文字描述-->
            <span v-if="scope.row.item === '文件描述'"><span v-html="scope.row.description"></span></span>
            <span v-if="scope.row.item === '文件类型'"><el-tag type="danger">{{scope.row.description}}</el-tag></span>
            <span v-if="scope.row.item !== '文件类型' && scope.row.item !== '文件描述'">{{scope.row.description}}</span>
            <!--操作行-->
            <span v-if="scope.row.item === '操作'">
              <!--下载按钮-->
              <el-button type="primary" plain @click="getDownloadLink">
                下载<i class="el-icon-download el-icon--right"></i>
              </el-button>
              <!--分享按钮-->
              <el-button type="warning" plain style="margin-left: 30px" disabled>
                复制链接<i class="el-icon-share el-icon--right"></i>
              </el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
          <el-button @click="pushToDownload">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CurrentLocal from '@/components/CurrentLocal/CurrentLocal'
import DownloadItem from '@/views/download/DownloadItem'
import { downloadItem, downloadItems } from '@/api/download'
import { getDownloadLinkUtil } from '@/utils/index'
import { Message } from 'element-ui'

export default {
  name: 'download',
  components: { DownloadItem, CurrentLocal },
  data () {
    return {
      total: 0,
      pages: 0,
      downloadItemsData: [],
      downloadItemData: {},
      dialogVisible: false,
      gridData: [
        {
          item: '文件名称',
          description: ''
        },
        {
          item: '文件类型',
          description: ''
        },
        {
          item: '文件大小',
          description: ''
        },
        {
          item: '已下载次数',
          description: ''
        },
        {
          item: '操作',
          description: ''
        },
        {
          item: '文件描述',
          description: ''
        }
      ],
      titles: [{ path: '/', name: '首页' },
        { path: '/download', name: '资料下载' }]
    }
  },
  created () {
    this.getDownloadItems()
  },
  methods: {
    getDownloadItems () {
      downloadItems().then(res => {
        this.total = res.body.total
        this.pages = res.body.pages
        this.downloadItemsData = res.body.list
      })
    },
    openDownloadDialog () {
      let uuid = this.$route.query.id
      downloadItem(uuid).then(res => {
        let itemBody = res.body
        if (itemBody.download_id !== null) {
          this.gridData[0].description = itemBody.download_title
          this.gridData[1].description = itemBody.download_type === null ? '无' : itemBody.download_type
          this.gridData[2].description = itemBody.download_size
          this.gridData[3].description = itemBody.download_times + ' 次'
          this.gridData[5].description = (itemBody.download_intro === null || itemBody.download_intro === '') ? '无' : itemBody.download_intro
          // this.gridData[4].description = itemBody.download_intro === null ? '无' : itemBody.download_intro
          this.dialogVisible = true
        } else {
          Message.error({
            message: '您输入的网址不正确！'
          })
        }
      })
    },
    closeDownloadDialog () {
      this.dialogVisible = false
    },
    pushToDownload () {
      this.$router.push('/download')
    },
    tableItemCenter ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return 'textCenter'
      }
    },
    getDownloadLink () {
      getDownloadLinkUtil(this.$route.query.id)
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        if (route.query.id === undefined) {
          this.closeDownloadDialog()
        } else {
          this.openDownloadDialog()
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  .el-table .textCenter {
    text-align: center;
  }
  .table-font {
    font-size: 16px;
  }
</style>
